export default "__VITE_ASSET__a692f021__"